<main class="h-screen">
  @if (!isDesktop()) {
    @if (isStationSelected()) {
      <app-station-details class="h-full" (backToResults)="clearSelection()" />
    } @else {
      <div class="flex flex-nowrap overflow-hidden">
        <div class="h-screen flex flex-col md:hidden basis-full flex-shrink-0">
          <div>
            <app-station-search [bu]="bu()"> </app-station-search>
            <lds-tabs
              [tabs]="tabs()"
              [selected]="selected()"
              (tabSelected)="tabSelected($event)"
              [attr.aria-label]="selectedTabLabel()"
              class="block mx-4"
            ></lds-tabs>
          </div>
          <app-location-count-label [stations]="stations()" />

          <div class="flex flex-nowrap flex-1 basis-full overflow-hidden md:hidden">
            <div
              class="flex-shrink-0 basis-full duration-300"
              [style]="activeTab() === TabView.Map ? '' : 'transform: translate(-100%)'"
            >
              <app-map-view [bu]="bu()" [stations]="stations()"></app-map-view>
            </div>
            <div
              class="flex-shrink-0 basis-full duration-300"
              [style]="
                activeTab() === TabView.List
                  ? 'transform: translateX(-100%); visibility: visible'
                  : 'visibility: hidden'
              "
            >
              <app-list-view [stations]="stations()"></app-list-view>
            </div>
          </div>
        </div>

        <div
          class="h-screen basis-full flex-shrink-0 duration-300"
          [style]="isFiltersViewOpened() ? 'transform: translateX(-100%); visibility: visible' : 'visibility: hidden'"
        >
          <app-stations-filters-view />
        </div>
      </div>
    }
  } @else {
    <div class="h-screen hidden md:flex flex-1 overflow-hidden">
      <div class="w-[40%] max-h-screen flex">
        <div class="max-h-screen w-full duration-300 flex-shrink-0 basis-full">
          <div class="flex flex-col h-screen">
            @if (isStationSelected()) {
              <app-station-details class="h-full" (backToResults)="clearSelection()" />
            } @else {
              <app-station-search [bu]="bu()"> </app-station-search>
              <app-location-count-label [stations]="stations()" />
              <app-list-view class="overflow-y-auto border-r border-gray-80" [stations]="stations()"></app-list-view>
            }
          </div>
        </div>
        <div
          class="h-screen flex-shrink-0 basis-full duration-300"
          [style]="isFiltersViewOpened() ? 'transform: translateX(-100%); visibility: visible' : 'visibility: hidden'"
        >
          <app-stations-filters-view />
        </div>
      </div>
      <app-map-view [bu]="bu()" class="w-[60%]" [stations]="stations()"></app-map-view>
    </div>
  }
</main>
